  
    import Multiselect from '@vueform/multiselect'
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue'; 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import MatriculaService from   "@/service/v1/sigap/MatriculaService"   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth');   


    @Options({
        name: "AlterarStatusMatricula",
        components: {  CardRh, Multiselect , BotaoSalvar },   
        emits: [ 'matricula-alterado'],  
    }) 
    export default class AlterarStatusMatricula extends Vue { 
        
        @Prop( ) readonly matricula!: any  
        
        @authStore.Getter
		public perfis!: any 

        public service = new MatriculaService();  
        
        public identificador = 1 ;   
        public status_id: any = 1
        public status: any = null;

        public observacao: any = null ;
        public dataPublicacao: any = null ;
        public dataAprovado: any = null ;
        public docPublicacao: any = null ;
        public mediaFinal: any = null ;
        
        public processando = false ;
        public editando = false ;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
         
        created(){    
            this.getStatus();  
            this.status_id = this.matricula.status.id;
            this.dataPublicacao = SiteUtils.formatDataToPadrao(this.matricula.dataPublicacao)
            this.dataAprovado = SiteUtils.formatDataToPadrao(this.matricula.dataAprovado)
            this.docPublicacao = this.matricula.docPublicacao;
            this.mediaFinal = this.matricula.mediaFinal;
            this.observacao = this.matricula.observacao;
        }


        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        
        get hasAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
        }

        get status_select(){
            if(this.status){
                return this.status.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }

        public getStatus(){   
            this.processando = true ; 
            this.service.getStatus(    ) 
            .then(response => {   
                this.status =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public AlterarAluno() {
            if( this.processando  ||  !this.hasPermissaoEditar  ){
                return;
            }
            this.processando = true ;   
            let dados: any = {
                id: this.matricula.id , 
                status: this.status_id , 
                dataPublicacao: this.dataPublicacao  ,
                observacao: this.observacao  ,
                docPublicacao: this.docPublicacao, 
            } 
            if(this.status_id == 6 ){
                if(this.matricula.isPendAcadProc || this.matricula.isPendAcadSaude){
                    SiteUtils.toastErro('Não é possivel aprovar o aluno com Pendências' , "" );
                    this.processando = false ;
                    return;
                }
                dados.mediaFinal= this.mediaFinal;
                dados.dataAprovado=  this.dataAprovado;
            }  
            this.service.AlterarAluno( this.matricula.id ,dados )
            .then(response => { 
                this.$emit("matricula-alterado", response);
                this.editando = false;
                this.processando = false ; 
            })
            .catch(errors => {
                this.processando = false ;
            });
        }
 
    } 
